import { render } from "./Jolly88Loading.vue?vue&type=template&id=92f52a8e&scoped=true"
const script = {}

import "./Jolly88Loading.vue?vue&type=style&index=0&id=92f52a8e&scoped=true&lang=scss"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f52a8e"]])

export default __exports__